/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  useRef,
  useEffect,
  createContext,
  useContext,
} from 'react';
import { css, jsx } from '@emotion/core';

import { colors } from 'styles/variables';

const { mint } = colors;

const PrevNextBtn = ({ label, onClick }) => {
  return (
    <div
      css={css`
        // position: absolute;
        ${label == 'prev' ? 'left: 25px;' : 'right: 25px;'}

        text-transform: capitalize;
        cursor: pointer;

        transition: color 0.3s;
        &:hover {
          // opacity: 0.8;
          color: ${mint};
        }
      `}
      onClick={onClick}
    >
      {label}
    </div>
  );
};

const PrevNextPage = ({ page, totalPages, updatePage }) => {
  return (
    <div
      css={css({
        position: 'absolute',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        left: 0,
        bottom: 10,
        width: '100%',
        // height: 25,
        padding: '0 30px',

        fontSize: 12,
      })}
    >
      <div
        style={{
          display: 'flex',
          flex: 1,
          justifyContent: 'flex-start',
        }}
      >
        {page > 1 && (
          <PrevNextBtn label="prev" onClick={() => updatePage('prev')} />
        )}
      </div>
      <div style={{ color: mint }}>
        {page} of {totalPages}
      </div>
      <div
        style={{
          display: 'flex',
          flex: 1,
          justifyContent: 'flex-end',
        }}
      >
        {page < totalPages && (
          <PrevNextBtn label="next" onClick={() => updatePage('next')} />
        )}
      </div>
    </div>
  );
};

export default PrevNextPage;
